/**
 * Zelf Zorgen Samen Doen
 *
 * @author Robuust
 * @author Rutger Bakker <rutger@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';
import { DotLottie } from '@lottiefiles/dotlottie-web';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import lottieLogo from '@/assets/lottie/logo.lottie'; // eslint-disable-line import/no-unresolved

/**
 * dotLottie controller
 */
export default class extends Controller {
  static values = {
    autoplay: {
      type: Boolean,
      default: false,
    },
  };

  /**
   * Lottie context.
   */
  ctx = null;

  /**
   * GSAP context.
   */
  gsapCtx = null;

  /**
   * Connect the Controller.
   */
  connect() {
    this.ctx = new DotLottie({
      canvas: this.element,
      src: lottieLogo,
      loop: false,
      autoplay: this.autoplayValue,
    });

    if (!this.autoplayValue) {
      this.gsapCtx = ScrollTrigger.create({
        trigger: this.element,
        start: 'top bottom',
        end: 'bottom bottom',
        onEnter: () => {
          this.ctx.play();
        },
        onLeaveBack: () => {
          this.ctx.stop();
        },
      });
    }
  }

  /**
   * Disconnect the controller.
   */
  disconnect() {
    this.ctx.destroy();

    if (this.gsapCtx) {
      this.gsapCtx.kill();
    }
  }
}
